import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  leftPanel: {
    boxShadow: "0 0 8px 0 rgba(0,0,0,.33)", backgroundColor: "#111116", minHeight: "100%",
  },
  countryContainer: {
    display: "flex",
    padding: "5px 10px",
    gap: 10,
  },
  navLinkText: { color: "white", marginTop: 20 },
  itemList: {
    color: "#f8f8f8",
    fontSize: "12px",
    listStyleType: "none",
    margin: 0,
    padding: 0,
    borderBottom: "1px solid #ddd"
  },
  citiesList: {
    background: "#f6f6f6",
    borderTop: "1px solid #cecece",
    position: "relative",
    margin: "5px -10px -5px",
    listStyleType: "none",
    padding: "3px 0",
    fontSize: "11px",
    display: "none",
    borderLeft: "3px solid #cb2845",
  },
  logo: {
    backgroundColor: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "14px",
    padding: "18px 12px",
    margin: 0,
    cursor: "pointer",
    '& > img': {
      height: "170px",
      width: "auto",
    },
  },
  logoText: {
    color: "#fff",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontWeight: 800,
    fontSize: "34px",
    lineHeight: 0.95,
    letterSpacing: ".02em",
    textAlign: "left",
  },
  logoRed: {
    color: "#d4163c",
  },
});

export { useStyles };
